var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inline-block invoice-container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "label",
        { staticClass: "small-4", class: { "required-flag": !_vm.readonly } },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("project.submission.invoiceNumber")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "small-4", class: { "required-flag": !_vm.readonly } },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("project.submission.invoiceAmount")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "small-4", class: { "required-flag": !_vm.readonly } },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("project.submission.invoiceDate")) +
              "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "invoice-number" }, [
        !_vm.readonly
          ? _c("input", {
              directives: [
                { name: "autosize", rawName: "v-autosize" },
                {
                  name: "fusioninputcheck",
                  rawName: "v-fusioninputcheck",
                  value: {
                    type: "string",
                    required: true,
                  },
                  expression:
                    "{\n          type:'string',\n          required: true\n        }",
                },
                { name: "hkldinput", rawName: "v-hkldinput" },
              ],
              class: { "error-highlight": _vm.highlightInvoiceNo },
              attrs: { type: "text", disabled: !_vm.canEdit },
              domProps: { value: (_vm.submission.invoice || {}).invoiceNumber },
              on: {
                change: function (e) {
                  return _vm.updateInvoiceInfo(e.target.value, "invoiceNumber")
                },
              },
            })
          : _c("p", { staticClass: "invoice-number-view" }, [
              _vm._v(
                "\n        " +
                  _vm._s((_vm.submission.invoice || {}).invoiceNumber) +
                  "\n      "
              ),
            ]),
      ]),
      _vm._v(" "),
      !_vm.readonly
        ? _c("div", { staticClass: "small-1 currency" }, [
            _vm._v("\n      " + _vm._s(_vm.currencyCode) + "\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "small-4 invoice-amount" }, [
        !_vm.readonly
          ? _c("input", {
              directives: [
                { name: "autosize", rawName: "v-autosize" },
                {
                  name: "fusioninputcheck",
                  rawName: "v-fusioninputcheck",
                  value: {
                    required: true,
                    type: "decimal",
                    pattern: function (val) {
                      return (Number((val || "").replace(/,/g, "")) || 0) >= 0
                    },
                  },
                  expression:
                    "{\n          required: true,\n          type: 'decimal',\n          pattern: (val) => (Number((val || '').replace(/,/g, '')) || 0) >= 0\n        }",
                },
                { name: "hkldinput", rawName: "v-hkldinput" },
              ],
              staticClass: "amount-input",
              class: { "error-highlight": _vm.highlightInvalidAmount },
              attrs: { disabled: !_vm.canEdit, type: "text" },
              domProps: { value: _vm.submission.completedAmount },
              on: {
                change: function (event) {
                  return _vm.updateCompleteAmount(event.target.value)
                },
              },
            })
          : _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("formatCurrency")(_vm.currentAmount, {
                      currencyCode: _vm.currencyCode,
                    })
                  ) +
                  "\n      "
              ),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "small-4" },
        [
          _vm.readonly
            ? _c("p", [
                _vm._v(
                  "\n        " + _vm._s(_vm.formatInvoiceDate()) + "\n      "
                ),
              ])
            : _c("DatePicker", {
                attrs: {
                  id: "sr-invoice-date-" + _vm.submission.invoice.id,
                  format: "DD MMM YY",
                  calendarButton: true,
                  required: true,
                  value: _vm.formatInvoiceDate(),
                  disabledPicker: !_vm.canEdit,
                  calendarButtonIcon: "fa fa-calendar",
                },
                on: {
                  selected: function (val) {
                    return _vm.updateInvoiceInfo(val, "invoiceDate")
                  },
                },
              }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }